import { useGatewayQuery } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import React from "react";
import { TestDataDocument } from "./__generated__/GatewayTest.v2.generated";

export const GatewayTest = () => {
  const { data } = useGatewayQuery(TestDataDocument);

  return (
    <div>
      <h1>Test Page</h1>
      <div>{data?.currentUser?.member.person.displayName}</div>
      <div>{data?.currentUser?.member.person.email}</div>
    </div>
  );
};
